import { useState } from 'react'
import { HelpIcon } from '@pulsex/uikit'

const BAD_SRCS: string[] = []

export interface LogoLoaderProps {
  alt: string
  size: string
  src: string
}

/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback to HelpIcon
 */
const LogoLoader: React.FC<LogoLoaderProps> = ({ src, alt, size, ...rest }) => {
  const [, refresh] = useState(0)

  const srcFailedLoading = BAD_SRCS.includes(src)

  if (src && !srcFailedLoading) {
    return (
      <img
        {...rest}
        height={parseInt(size, 10)}
        width={parseInt(size, 10)}
        alt={alt}
        src={src}
        onError={() => {
          if (src) BAD_SRCS.push(src)
          refresh((i) => i + 1)
        }}
      />
    )
  }

  return <HelpIcon {...rest} />
}

export default LogoLoader
